import cn from 'clsx';
import React from 'react';

import Icon from '../../Icon';

import s from './FeedbackDescription.module.scss';
import { IFeedbackDescriptionProps, IIconProps, statusIconObj } from './FeedbackDescription.types';

const StatusIcon = React.memo(({ status, hasStatusIcon }: IIconProps) => {
  if (!hasStatusIcon) return null;
  return (
    <div className={s.icon}>
      <Icon type={statusIconObj[status]} size={16} />
    </div>
  );
});

const LinkIcon = React.memo(({ hasLinkIcon }: Pick<IIconProps, 'hasLinkIcon'>) => {
  if (!hasLinkIcon) return null;
  return (
    <div className={s['link-icon']}>
      <Icon type="arrow-right" width={15} height={20} />
    </div>
  );
});

const FeedbackDescription = ({
  className,
  text = '성공 내용을 적어주세요',
  status = 'success',
  hasBg = true,
  hasStatusIcon = true,
  hasLinkIcon = true
}: IFeedbackDescriptionProps) => {
  return (
    <div className={cn(s.description, s[status], hasBg && s.isBg, className)}>
      <div className={s.inner}>
        <StatusIcon hasStatusIcon={hasStatusIcon} status={status} />
        <p className={s.text}>{text}</p>
      </div>
      <LinkIcon hasLinkIcon={hasLinkIcon} />
    </div>
  );
};
export default FeedbackDescription;
